import { AxiosError } from 'axios';
import useSWR from 'swr';

import { UseContractPropsT } from './useContract';
import { apiEndpoints, dashboardFetchers } from '../lib';

export const useContractPDF = ({ accountId, loanNumber }: UseContractPropsT) => {
  // eslint-disable-next-line @stylistic/object-curly-newline
  const { data, error, isLoading } = useSWR<Blob, AxiosError>(
    () => (accountId && loanNumber ? apiEndpoints.dashboard.contractPDF(accountId, loanNumber) : null),
    dashboardFetchers.getBlob,
  );

  return {
    data,
    error,
    isLoading,
  };
};
